export default __webpack_public_path__ + "static/media/sample.b46cc645.PNG";